import api from '../../../services/api';

const customerRequestServices = {
  createCustomerRequest(payload: CreateCustomerRequestDTO) {
    return api.post('/customer-request', payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },

  getCustomerRequest(id: number) {
    return api.get('/customer-request/' + id, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },
};

export default customerRequestServices;

export interface AdditionalOptionValueDTO {
  additional_option_id: number;
  value: string | number | boolean;
}

export interface CreateCustomerRequestDTO {
  referral_id: number;
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  additional_comments?: string;
  additional_option_values?: AdditionalOptionValueDTO[];
  requested_date: string; // ISO 8601 format (e.g., '2025-01-15T00:00:00Z')
  requested_time: string; // HH:mm:ss+TZ format (e.g., '14:30:00+00')
  price: number;
}
